import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { StyleProps, createStyles } from '../utils/create-styles'

export type DivProps = {
  children?: ReactNode
  styles?: StyleProps
}

export const Div = styled.div<DivProps>((props) => {
  return createStyles(props.styles)
})
